function StudioMixes() {
    return(
        <div className='mixes-body'>
            <h2>Selected Mixes From Studio Sessions</h2>
            <p>These are Studio or Home Recording I mixed for artists assimilating thier feedback and preferences for the mix.
            </p>
            <div className='album-container'>
            <iframe
                    style={{ borderRadius: '12px' }}
                    src="https://open.spotify.com/embed/album/1MU7NSTSyLDqSruyailbtW?utm_source=generator&theme=0"
                    width="100%"
                    height="352"
                    frameBorder="0"
                    allowFullScreen
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                    loading="lazy"
                ></iframe>
                    <iframe
                    className="album-embed"
                    style={{ borderRadius: '12px' }}
                    src="https://open.spotify.com/embed/album/7ksvw2mZZh8Z29tsgaN59N?utm_source=generator"
                    width="100%"
                    height="352"
                    frameBorder="0"
                    allowFullScreen
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                    loading="lazy"
                    ></iframe> 

                    <iframe style={{ border: '0', width: '100%', height: '120px' }} 
                    src="https://open.spotify.com/embed/album/4iLgrqhGoJSKBjzVEIfY4v?utm_source=generator"  
                    frameBorder="0" 
                    allowfullscreen="" 
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
                    loading="lazy">
                    </iframe>
                    
                    <iframe
                    className="album-embed"
                    style={{ borderRadius: '0' }}
                    width="350px"
                    height="470px"
                    src="https://bandcamp.com/EmbeddedPlayer/album=1232780523/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/"
                    seamless
                    >
                    <a href="https://kasatasound.bandcamp.com/album/leave-early-for-the-north-ep">
                        Leave Early For The North EP by Kasata Sound
                    </a>
                    </iframe>

                    <iframe
                    className="album-embed"
                        width="100%"
                        height="166"
                        scrolling="no"
                        frameBorder="0"
                        allow="autoplay"
                        src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/125173460&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
                        ></iframe>
                        <div
                        style={{
                            fontSize: '10px',
                            color: '#cccccc',
                            lineBreak: 'anywhere',
                            wordBreak: 'normal',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            fontFamily: 'Interstate, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Garuda, Verdana, Tahoma, sans-serif',
                            fontWeight: 100,
                        }}
                        >
                        <a
                            href="https://soundcloud.com/kasatasound"
                            title="Kasata Sound"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#cccccc', textDecoration: 'none' }}
                        >
                            Kasata Sound
                        </a>
                        {' '}·{' '}
                        <a
                            href="https://soundcloud.com/kasatasound/dubhall"
                            title="DubHall"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#cccccc', textDecoration: 'none' }}
                        >
                            DubHall
                        </a>
                        </div>
                    <iframe
                    className="album-embed"
                        width="100%"
                        height="166"
                        scrolling="no"
                        frameBorder="0"
                        allow="autoplay"
                        src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/159846459&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
                        ></iframe>
                        <div
                        style={{
                            fontSize: '10px',
                            color: '#cccccc',
                            lineBreak: 'anywhere',
                            wordBreak: 'normal',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            fontFamily: 'Interstate, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Garuda, Verdana, Tahoma, sans-serif',
                            fontWeight: 100,
                        }}
                        >
                        <a
                            href="https://soundcloud.com/kasatasound"
                            title="Kasata Sound"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#cccccc', textDecoration: 'none' }}
                        >
                            Kasata Sound
                        </a>
                        {' '}·{' '}
                        <a
                            href="https://soundcloud.com/kasatasound/local-intelligence"
                            title="Local Intelligence"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#cccccc', textDecoration: 'none' }}
                        >
                            Local Intelligence
                        </a>
                        </div>
            </div>
        </div>
    )
    };
    
    export default StudioMixes;